export const MILWAUKEE_AREAS = [
  'Bay View',
  'Brady Street',
  "Brewer's Hill",
  'Burnham Park',
  'Cambridge Woods',
  'Clock Tower Acres',
  'Concordia',
  'Cooper Park',
  'Downtown',
  'East Side',
  'East Village',
  'Enderis Park',
  'Franklin Heights',
  'Garden Homes',
  'Granville',
  'Harbor View',
  'Harambee',
  'Historic Third Ward',
  'Holler Park',
  'Jackson Park',
  'Layton Park',
  'Lincoln Village',
  'Lower East Side',
  'Merrill Park',
  'Metcalfe Park',
  'Midtown',
  "Miller's Valley",
  'Murray Hill',
  'North Division',
  'Pigsville',
  'Riverwest',
  'Sherman Park',
  'Silver City',
  'South Side',
  'Story Hill',
  'Sunset Heights',
  'Triangle',
  'Uptown',
  "Walker's Point",
  'Washington Heights',
  'Washington Park',
  'West End',
  'Williamsburg Heights',
  'Yankee Hill',
];

export const BOSTON_AREAS = [
  'Allston',
  'Back Bay',
  'Bay Village',
  'Beacon Hill',
  'Brighton',
  'Charlestown',
  'Chinatown',
  'Dorchester',
  'Downtown',
  'East Boston',
  'Fenway',
  'Hyde Park',
  'Jamaica Plain',
  'Kenmore',
  'Leather District',
  'Longwood',
  'Mattapan',
  'Mission Hill',
  'North End',
  'Roslindale',
  'Roxbury',
  'South Boston',
  'South End',
  'West End',
  'West Roxbury',
];

export const PORTLAND_AREAS = [
  'Alameda',
  'Arbor Lodge',
  'Ardenwald-Johnson Creek',
  'Argay',
  'Arlington Heights',
  'Arnold Creek',
  'Beaumont-Wilshire',
  'Boise',
  'Brentwood-Darlington',
  'Bridlemile',
  'Brooklyn',
  'Buckman',
  'Cathedral Park',
  'Collins View',
  'Concordia',
  'Creston-Kenilworth',
  'Cully',
  'Downtown',
  'East Columbia',
  'Eastmoreland',
  'Eliot',
  'Far Southwest',
  'Forest Park',
  'Foster-Powell',
  'Glenfair',
  'Goose Hollow',
  'Grant Park',
  'Hayden Island',
  'Hayhurst',
  'Hazelwood',
  'Healy Heights',
  'Hillsdale',
  'Hillside',
  'Hollywood',
  'Homestead',
  'Hosford-Abernethy',
  'Humboldt',
  'Irvington',
  'Kenton',
  'Kerns',
  'King',
  'Laurelhurst',
  'Lents',
  'Linnton',
  'Lloyd District',
  'Madison South',
  'Maplewood',
  'Markham',
  'Marshall Park',
  'Mill Park',
  'Montavilla',
  'Mount Scott-Arleta',
  'Mount Tabor',
  'Multnomah',
  'North Tabor',
  'Northwest District',
  'Northwest Heights',
  'Old Town',
  'Overlook',
  'Parkrose',
  'Parkrose Heights',
  'Pearl District',
  'Piedmont',
  'Pleasant Valley',
  'Portsmouth',
  'Powellhurst-Gilbert',
  'Reed',
  'Richmond',
  'Rose City Park',
  'Roseway',
  'Russell',
  'Sabin',
  'Sellwood-Moreland',
  'South Burlingame',
  'South Portland',
  'South Tabor',
  'Southwest Hills',
  'St. Johns',
  "Sullivan's Gulch",
  'Sumner',
  'Sunderland',
  'Sunnyside',
  'Sylvan-Highlands',
  'University Park',
  'Vernon',
  'West Portland Park',
  'Wilkes',
  'Woodland Park',
  'Woodlawn',
  'Woodstock',
];

export const NYC_BOROUGHS = [
  {
    name: 'Manhattan',
    areas: [
      'Alphabet City',
      'Battery Park City',
      'Bowery',
      'Carnegie Hill',
      'Chelsea',
      'Chinatown',
      'Civic Center',
      'East Harlem',
      'East Village',
      'Financial District',
      'Flatiron',
      'Gramercy',
      'Greenwich Village',
      'Hamilton Heights',
      'Harlem',
      "Hell's Kitchen",
      'Hudson Yards',
      'Inwood',
      'Kips Bay',
      'Koreatown',
      'Lenox Hill',
      'Lincoln Square',
      'Little Italy',
      'Lower East Side',
      'Manhattan Valley',
      'Marble Hill',
      'Midtown',
      'Morningside Heights',
      'Murray Hill',
      'NoHo',
      'Nolita',
      'SoHo',
      'Stuyvesant Town',
      'Sugar Hill',
      'Sutton Place',
      'Theater District',
      'Tribeca',
      'Tudor City',
      'Turtle Bay',
      'Two Bridges',
      'Upper East Side',
      'Upper West Side',
      'Washington Heights',
      'West Village',
      'Yorkville',
    ],
  },
  {
    name: 'Brooklyn',
    areas: [
      'Bath Beach',
      'Bay Ridge',
      'Bedford-Stuyvesant',
      'Bensonhurst',
      'Bergen Beach',
      'Boerum Hill',
      'Borough Park',
      'Brighton Beach',
      'Brooklyn Heights',
      'Brownsville',
      'Bushwick',
      'Canarsie',
      'Carroll Gardens',
      'Clinton Hill',
      'Cobble Hill',
      'Coney Island',
      'Crown Heights',
      'Cypress Hills',
      'Ditmas Park',
      'Downtown Brooklyn',
      'DUMBO',
      'Dyker Heights',
      'East New York',
      'East Williamsburg',
      'Flatbush',
      'Flatlands',
      'Fort Greene',
      'Fort Hamilton',
      'Gerritsen Beach',
      'Gowanus',
      'Gravesend',
      'Greenpoint',
      'Greenwood Heights',
      'Kensington',
      'Manhattan Beach',
      'Marine Park',
      'Midwood',
      'Mill Basin',
      'Ocean Hill',
      'Park Slope',
      'Prospect Heights',
      'Prospect Lefferts Gardens',
      'Red Hook',
      'Seagate',
      'Sheepshead Bay',
      'South Slope',
      'South Williamsburg',
      'Sunset Park',
      'Vinegar Hill',
      'Williamsburg',
      'Windsor Terrace',
    ],
  },
  {
    name: 'Queens',
    areas: [
      'Arverne',
      'Astoria',
      'Auburndale',
      'Bayside',
      'Bellerose',
      'Breezy Point',
      'Broad Channel',
      'Cambria Heights',
      'College Point',
      'Corona',
      'Ditmars-Steinway',
      'Douglaston',
      'East Elmhurst',
      'Elmhurst',
      'Far Rockaway',
      'Floral Park',
      'Flushing',
      'Forest Hills',
      'Fresh Meadows',
      'Glendale',
      'Glen Oaks',
      'Hollis',
      'Howard Beach',
      'Hunters Point',
      'Jackson Heights',
      'Jamaica',
      'Jamaica Estates',
      'Kew Gardens',
      'Kew Gardens Hills',
      'Laurelton',
      'Little Neck',
      'Long Island City',
      'Maspeth',
      'Middle Village',
      'Oakland Gardens',
      'Ozone Park',
      'Queens Village',
      'Rego Park',
      'Richmond Hill',
      'Ridgewood',
      'Rockaway Beach',
      'Rockaway Park',
      'Rosedale',
      'South Jamaica',
      'South Ozone Park',
      'Springfield Gardens',
      'St. Albans',
      'Sunnyside',
      'Whitestone',
      'Woodhaven',
      'Woodside',
    ],
  },
  {
    name: 'Bronx',
    areas: [
      'Allerton',
      'Baychester',
      'Bedford Park',
      'Belmont',
      'Castle Hill',
      'City Island',
      'Clason Point',
      'Concourse',
      'Co-op City',
      'Country Club',
      'East Tremont',
      'Edenwald',
      'Fieldston',
      'Fordham',
      'Highbridge',
      'Hunts Point',
      'Kingsbridge',
      'Kingsbridge Heights',
      'Longwood',
      'Melrose',
      'Morrisania',
      'Morris Heights',
      'Morris Park',
      'Mott Haven',
      'Norwood',
      'Parkchester',
      'Pelham Bay',
      'Pelham Parkway',
      'Port Morris',
      'Riverdale',
      'Soundview',
      'Spuyten Duyvil',
      'Throgs Neck',
      'Tremont',
      'University Heights',
      'Van Nest',
      'Wakefield',
      'Westchester Square',
      'Williamsbridge',
      'Woodlawn',
    ],
  },
  {
    name: 'Staten Island',
    areas: [
      'Annadale',
      'Arden Heights',
      'Arrochar',
      'Bay Terrace',
      'Bloomfield',
      'Bulls Head',
      'Castleton Corners',
      'Charleston',
      'Clifton',
      'Concord',
      'Dongan Hills',
      'Eltingville',
      'Elm Park',
      'Grant City',
      'Great Kills',
      'Grymes Hill',
      'Huguenot',
      'Mariners Harbor',
      'Midland Beach',
      'New Brighton',
      'New Dorp',
      'New Springville',
      'Oakwood',
      'Pleasant Plains',
      'Port Richmond',
      "Prince's Bay",
      'Randall Manor',
      'Richmond Valley',
      'Rosebank',
      'Rossville',
      'Shore Acres',
      'Silver Lake',
      'South Beach',
      'St. George',
      'Stapleton',
      'Todt Hill',
      'Tompkinsville',
      'Tottenville',
      'Travis',
      'West Brighton',
      'Westerleigh',
      'Willowbrook',
      'Woodrow',
    ],
  },
];
